import {Button, Form, Modal, ModalBody, ModalHeader} from "reactstrap";
import {Col, Row} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import ReactTooltip from "react-tooltip";
import TextInput from "../Inputs/TextInput";
import SelectInput from "../Inputs/SelectInput";
import TextAreaInput from "../Inputs/TextAreaInput";
import CheckboxInput from "../Inputs/CheckboxInput";
import {MultiSelect} from "react-multi-select-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import "../../assets/scss/tooltip.scss";

import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

const AddVoting = (props) => {
    const {t} = useTranslation();
    const errors = useSelector(state => state.errors);
    const [show_form, setShowForm] = useState(false);
    const [option_form_data, setOptionFormData] = useState({
        label: '',
    })

    const {participants} = useSelector(state => state.participants)
    const [participant_options, setParticipantOptions] = useState([])

    useEffect(() => {
        let option_object = participants.map(particpant => {
            return {label: particpant.name, value: particpant.id};

        })
        setParticipantOptions(option_object); // eslint-disable-next-line
    },[])

    const handleInputChange = (e) => {
        const {name, value} = e.target;
        if (name === "type") {
            if ((props.formData.type === "select_default" || props.formData.type === "select" || props.formData.type === "multi_select") && value === "text") {
                props.setFormData(prevState => ({...prevState, options: []}));
            }
            if (props.formData.type === "text" && (value === "multi_select" || value === "select")) {
                props.setFormData(prevState => ({...prevState, options: []}));
            }
            if (value === 'read_and_confirm') {
                props.setFormData(prevState => ({...prevState, options: []}));
            }
        }

        if (name === "required") {
            props.setFormData(state => ({...state, required: !props.formData.required}))
        } else if (name === "is_motion") {
            if (!props.formData.is_motion === true) {
                props.setFormData(state => ({
                    ...state,
                    is_motion: true,
                    description: props.formData.motion,
                    title: "Beschlussantrag"
                }))
            } else {
                props.setFormData(state => ({...state, is_motion: !props.formData.is_motion}))
            }
        } else if (name === "type" && value === "select_default") {
            props.setFormData(prevState => ({...prevState, options: [{label: "Ja"},{label: "Nein"},{label: "Enthaltung"}]}))
            props.setFormData(prevState => ({...prevState, [name]: "select"}));
        }
        else {
            props.setFormData(prevState => ({...prevState, [name]: value}));
        }

    }

    const handleOptionInutchange = (e) => {
        const {name, value} = e.target;
        setOptionFormData(prevState => ({...prevState, [name]: value}))
    }

    const toggleOptionForm = () => {
        setShowForm(!show_form);
    }

    const addOption = () => {
        const tmp_data = props.formData.options.concat(option_form_data);
        props.setFormData(prevState => ({...prevState, options: tmp_data}))
        setOptionFormData({
            label: '',
        })
    }

    const renderOptionLimitInput = () => {
        if (props.formData.type === "multi_select") {
            return (<SelectInput
                name="options_limit"
                value={props.formData.options_limit}
                label={t('input.options_limit')}
                placeholder={t('placeholder.options_limit')}
                handleInputChange={handleInputChange}
                options={{
                    '0': 'unbegrenzt',
                    '1': '1',
                    '2': '2',
                    '3': '3',
                    '4': '4',
                    '5': '5',
                    '6': '6',
                    '7': '7',
                    '8': '8',
                    '9': '9',
                    '10': '10',

                }}
            />)
        }

        return null;
    }

    const deleteOption = (element_index) => {
        const tmp_data = props.formData.options.filter((option, key) => key !== element_index);
        props.setFormData(prevState => ({...prevState, options: tmp_data}))

    }

    const renderOptionTable = () => {
        if (props.formData.options.length) {

            return props.formData.options.map((item, index) => {
                return (
                    <div>
                        <span>{item.label}</span>
                        <Button color="danger" onClick={() => deleteOption(index)}>
                            <i className="dripicons-trash"></i>
                        </Button>
                    </div>
                )
            })
        }

    }

    const renderFormButton = () => {

        if (props.formData.type !== '') {
            if (props.formData.type === "text" && props.formData.options.length > 0) {
                return <span style={{color: '#fa5c7c'}}>Für den Typ <strong>Text</strong> kann nur eine Option angegeben werden</span>
            } else if (props.formData.type === "read_and_confirm" && props.formData.options.length > 0) {
                return <span style={{color: '#fa5c7c'}}>Für den Typ <strong>Bestätigen</strong> kann nur eine Option angegeben werden</span>
            } else {
                if (show_form) {
                    return <Button color="danger" onClick={toggleOptionForm}>{t('button.abort')}</Button>
                } else {
                    return <Button color="primary" onClick={toggleOptionForm}>{t('input.voting_label')}</Button>
                }
            }

        } else {
            return <Button color="primary" disabled={true}>{t('description.type_choose')}</Button>
        }

    }

    const renderForm = () => {
        if (show_form) {
            if (props.formData.type === 'select' || props.formData.type === 'multi_select') {

                return (
                    <>
                        <p>{t('input.voting_select')}</p>
                        <div>
                            <TextInput
                                placeholder={t('placeholder.voting_select')}
                                name="label"
                                handleInputChange={handleOptionInutchange}
                                value={option_form_data.label}
                            />
                            <Button onClick={addOption} color="primary"><i
                                className="dripicons-checkmark"></i></Button>
                        </div>
                    </>
                )

            } else if (props.formData.type === 'read_and_confirm') {
                if (props.formData.options.length <= 0) {
                    return (
                        <div>
                            <TextAreaInput
                                placeholder={t('placeholder.text')}
                                name="label"
                                handleInputChange={handleOptionInutchange}
                                value={option_form_data.label}
                                rows={3}
                                cols={50}
                            />
                            <Button className="textarea-button" onClick={addOption} color="primary"><i className="dripicons-checkmark"></i></Button>
                        </div>
                    )
                }
            } else {
                if (props.formData.options.length <= 0) {
                    return (
                        <div>
                            <TextInput
                                placeholder={t('placeholder.label')}
                                name="label"
                                handleInputChange={handleOptionInutchange}
                                value={option_form_data.label}
                            />
                            <Button onClick={addOption} color="primary"><i className="dripicons-checkmark"></i></Button>
                        </div>
                    )
                }
            }
        }
    }

    const change = (e) => {
        props.setFormData(prevState => ({...prevState, not_allowed_participants: e}));
    }

    const renderOptionFeedback = () => {
        let feedBack_style = {
            color: "#fa5c7c",
            fontSize: "0.75rem",
            fontWeight: "400"

        }

        if (Object.entries(errors.errors).length !== 0) {
            if (errors.errors["options"]) {
                return (
                    <div>
                        <p style={feedBack_style}>{t('error.options')}</p>
                    </div>
                )
            }
        }
    }



    return (
        <Modal size="lg" id="addVotingModal" onExit={props.handleClose} isOpen={props.modal} backdrop="static" toggle={props.toggle} className="modal-dialog-centered">
            <ModalHeader toggle={props.toggle}>{t('button.voting.create')}</ModalHeader>
            <ModalBody>
                <Form onSubmit={props.handleSubmit}>
                    <Row>
                        <Col>
                            {!props.formData.motion_exists ? <CheckboxInput
                                name="is_motion"
                                label={t('input.is_motion')}
                                handleInputChange={handleInputChange}
                                value=""
                                checked={props.formData.is_motion}
                            /> : <p><strong>{t('general.attention')}</strong><br/>{t('description.motion_exists')}</p>}
                            {!props.formData.motion_exists ? <p>{t('description.is_motion')}</p> : ""}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <p className="d-inline-block mb-1" >{t('input.voting_title')}*</p>
                            <FontAwesomeIcon data-tip data-for="registerTip" className="ml-1 custtooltip-trigger" icon={faInfoCircle} />
                            <ReactTooltip className="custtooltip" id="registerTip" place="top" effect="solid">
                                {t('description.voting_title')}
                            </ReactTooltip>

                            <TextInput
                                name="title"
                                value={props.formData.title}
                                placeholder={t('placeholder.voting_title')}
                                handleInputChange={handleInputChange}
                            />

                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <p className="d-inline-block mb-1" >{t('input.description')}*</p>
                            <FontAwesomeIcon data-tip data-for="description" className="ml-1 custtooltip-trigger" icon={faInfoCircle} />
                            <ReactTooltip className="custtooltip" id="description" place="top" effect="solid">
                                {t('description.description')}
                            </ReactTooltip>
                            <TextAreaInput
                                name="description"
                                value={props.formData.description}
                                placeholder={t('placeholder.description')}
                                handleInputChange={handleInputChange}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <p className="d-inline-block mb-1" >{t('general.voting_type')}*</p>
                            <FontAwesomeIcon data-tip data-for='choices' className='ml-1 custtooltip-trigger' icon={faInfoCircle} />
                            <ReactTooltip className="custtooltip" id="choices" place="top" effect="solid">
                                {t('description.voting_type')}
                            </ReactTooltip>
                            <div className="no-label">
                                <SelectInput
                                    name="type"
                                    value={props.formData.type}
                                    placeholder={t('placeholder.voting_type')}
                                    handleInputChange={handleInputChange}
                                    options={{
                                        'select_default': 'Einfache Auswahl (Ja / Nein / Enthaltung)',
                                        'select': 'Einfache Auswahl (Eigene Optionen)',
                                        'multi_select': 'Mehrfach Auswahl',
                                        'read_and_confirm': 'Bestätigung durch Teilnehmer',
                                        'text': 'Texteingabe durch Teilnehmer',
                                    }}
                                />
                            </div>

                        </Col>

                        <Col>
                            <div className="form-group">
                                <p className="d-inline-block mb-1" >{t('general.not_allowed_participants')}</p>
                                <FontAwesomeIcon id="not_allowed" data-tip data-for="not_allowed" className="ml-1 custtooltip-trigger" icon={faInfoCircle} />
                                <ReactTooltip className="custtooltip" id="not_allowed" place="top" effect="solid">
                                    {t('description.not_allowed_participants')}
                                </ReactTooltip>
                                <MultiSelect
                                    options={participant_options}
                                    value={props.formData.not_allowed_participants}
                                    onChange={change}
                                    labelledBy={"Select"}
                                    overrideStrings={{
                                        "allItemsAreSelected": "Alle Teilnehmer wurden ausgewählt.",
                                        "clearSearch": "Suche leeren",
                                        "noOptions": "Keine Teilnehmer verfügbar",
                                        "search": "Suchen",
                                        "selectAll": "Alle auswählen",
                                        "selectSomeItems": "Auswählen..."
                                    }}
                                />
                            </div>

                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {renderOptionLimitInput()}
                        </Col>
                    </Row>


                    <Row>
                        <Col>
                            {renderFormButton()}
                        </Col>
                    </Row>
                    <Row>
                        <Col id="voting_options">
                            {renderForm()}
                            {renderOptionTable()}
                            {renderOptionFeedback()}
                        </Col>
                    </Row>


                    <div className="processingButtons">
                        <Button color="lightgray" onClick={props.toggle}>{t('button.abort')}</Button>
                        <Button color="primary" onClick={props.handleSubmit}>{t('button.create')}</Button>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    )
}

export default AddVoting;